import Vuex from "vuex";

export default new Vuex.Store({
  state: {
    selectDateIndex: 0,
    caldendarDefaultDate: new Date(),
    selectDate: new Date(),
    dateList: [],
  },
  mutations: {
    setDateList(state, value) {
      state.dateList = value;
    },
    setSelectDateIndex(state, value) {
      state.selectDateIndex = value;
    },
    setDefaultDate(state, value) {
      state.caldendarDefaultDate = value;
    },
    setSelectDate(state, value) {
      state.selectDate = value;
    },
    initializeState(state, value) {
      //console.log(111);
      for (let key in state) {
        state[key] = value[key];
      }
    },
  },
});
